import React, { useState } from "react";
import SEO from "../components/seo";
import { colors, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { IconContext } from "react-icons";
import { FaLinkedin, FaTwitter } from "react-icons/fa";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import profilePhoto from "../images/profile.png";
import Avatar from "@material-ui/core/Avatar";
import "../components/base.css";

const useStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: colors.blueGrey["800"],
    color: colors.blueGrey[100],
    minHeight: "100vh"
  },
  hero: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: "100vh",
    width: "100%"
  },
  iconBar: {
    marginTop: "5vh"
  },
  social: {
    display: "inline",
    color: colors.blueGrey["100"],
    transition: "color 1s ease",
    marginLeft: "1rem",
    width: "2rem",
    height: "2rem",
    "&:hover": {
      color: "white",
      cursor: "pointer"
    }
  },
  avatar: {
    width: "12rem",
    height: "12rem",
    marginBottom: "5vh"
  },
  bio: {
    maxWidth: "560px",
    marginTop: "2vh",
    lineHeight: "1.8",
    color: colors.blueGrey[200],
    fontSize: "1rem",
    padding: "0 1.5rem"
  },
  contactSection: {
    width: "100%",
    maxWidth: "560px",
    padding: "4rem 1.5rem",
    textAlign: "center"
  },
  contactTitle: {
    marginBottom: "2rem",
    color: colors.blueGrey[100]
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem"
  },
  input: {
    backgroundColor: colors.blueGrey["700"],
    border: "none",
    borderBottom: `2px solid ${colors.blueGrey["400"]}`,
    color: colors.blueGrey[100],
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    borderRadius: "4px",
    outline: "none",
    transition: "border-color 0.3s ease",
    "&:focus": {
      borderBottomColor: "white"
    }
  },
  textarea: {
    backgroundColor: colors.blueGrey["700"],
    border: "none",
    borderBottom: `2px solid ${colors.blueGrey["400"]}`,
    color: colors.blueGrey[100],
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    borderRadius: "4px",
    outline: "none",
    resize: "vertical",
    minHeight: "120px",
    fontFamily: "inherit"
  },
  button: {
    backgroundColor: "transparent",
    border: `2px solid ${colors.blueGrey["400"]}`,
    color: colors.blueGrey[100],
    padding: "0.75rem 2rem",
    fontSize: "1rem",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    alignSelf: "center",
    "&:hover": {
      borderColor: "white",
      color: "white"
    }
  },
  successMessage: {
    color: colors.blueGrey[200],
    marginTop: "1rem"
  }
});

const IndexPage = () => {
  const classes = useStyles();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({ "form-name": "contact", ...formData }).toString()
    })
      .then(() => setSubmitted(true))
      .catch(() => setSubmitted(true));
  };

  return (
    <div className={classes.page}>
      <SEO title="M. Seyda Tartar" />

      <div className={classes.hero}>
        <Avatar
          alt="M. Seyda Tartar"
          src={profilePhoto}
          className={classes.avatar}
        />
        <Typography gutterBottom variant="h3">
          Hello, I'm Seyda
        </Typography>
        <Typography gutterBottom variant="h4">
          A technophile
        </Typography>
        <Typography className={classes.bio}>
          IT &amp; Digital professional with 15+ years of international experience.
          Currently at SunExpress in Frankfurt, I bridge the gap between technology
          and business — passionate about building digital products and leading agile
          teams. Certified Scrum Master, Product Owner &amp; PRINCE2 Practitioner.
        </Typography>

        <div className={classes.iconBar}>
          <IconContext.Provider value={{ className: classes.social }}>
            <OutboundLink
              href="https://www.linkedin.com/in/mseyda/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaLinkedin />
            </OutboundLink>
            <OutboundLink
              href="https://twitter.com/mseyda"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FaTwitter />
            </OutboundLink>
          </IconContext.Provider>
        </div>
      </div>

      <div className={classes.contactSection}>
        <Typography variant="h5" className={classes.contactTitle}>
          Get in touch
        </Typography>

        {submitted ? (
          <Typography className={classes.successMessage}>
            Thanks! I'll get back to you soon.
          </Typography>
        ) : (
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className={classes.form}
          >
            <input type="hidden" name="form-name" value="contact" />
            <input
              className={classes.input}
              type="text"
              name="name"
              placeholder="Your name"
              required
              onChange={handleChange}
            />
            <input
              className={classes.input}
              type="email"
              name="email"
              placeholder="Your email"
              required
              onChange={handleChange}
            />
            <textarea
              className={classes.textarea}
              name="message"
              placeholder="Your message"
              required
              onChange={handleChange}
            />
            <button type="submit" className={classes.button}>
              Send
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default IndexPage;
